var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t(_vm.isAddForecast ? "addForecast" : "forecastDetail"),
      rightMethod: _vm.submit,
      rightButtonDisabled:
        _vm.isEmpty || (!_vm.isAddForecast && _vm.forecast.status !== "ready"),
      hasAlert: "",
      rightButtonLoading: _vm.isLoading,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _vm.isAddForecast
              ? _c(
                  "v-flex",
                  { attrs: { md7: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md3: "", "mr-3": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items: _vm.forecastWarehouses,
                                "item-text": "warehouseName",
                                "item-value": "warehouseKey",
                                "return-object": "",
                                label: _vm.$t("warehouse")
                              },
                              model: {
                                value: _vm.forecast.curWarehouse,
                                callback: function($$v) {
                                  _vm.$set(_vm.forecast, "curWarehouse", $$v)
                                },
                                expression: "forecast.curWarehouse"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md3: "", "mr-3": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items:
                                  (_vm.forecast.curWarehouse &&
                                    _vm.forecast.curWarehouse.sites) ||
                                  [],
                                label: _vm.$t("warehouseSite"),
                                "item-text": "siteName",
                                "item-value": "key",
                                "return-object": false
                              },
                              model: {
                                value: _vm.forecast.warehouseSite,
                                callback: function($$v) {
                                  _vm.$set(_vm.forecast, "warehouseSite", $$v)
                                },
                                expression: "forecast.warehouseSite"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md3: "", "mr-3": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items: [
                                  { text: _vm.$t("air"), value: "air" },
                                  { text: _vm.$t("ocean"), value: "ocean" },
                                  { text: _vm.$t("ground"), value: "ground" }
                                ],
                                "item-text": "text",
                                "item-value": "value",
                                label: _vm.$t("shipType")
                              },
                              model: {
                                value: _vm.forecast.shipType,
                                callback: function($$v) {
                                  _vm.$set(_vm.forecast, "shipType", $$v)
                                },
                                expression: "forecast.shipType"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddForecast || _vm.forecast.status === "ready"
              ? _c(
                  "v-flex",
                  [
                    _c(
                      "v-layout",
                      { attrs: { "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md11: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _vm.canEdit()
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary" },
                                        on: { click: _vm.addItem }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { dark: "", left: "" } },
                                          [_vm._v("add")]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("package")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      title: "importFile",
                                      loading: _vm.isUploading,
                                      disabled: _vm.isUploadBtnDisabled
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { dark: "", left: "" } },
                                      [_vm._v("cloud_upload")]
                                    ),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("upload")) +
                                        "\n                "
                                    ),
                                    _c("input", {
                                      staticClass: "hideInput",
                                      attrs: {
                                        type: "file",
                                        accept: ".csv,.xls,.xlsx"
                                      },
                                      on: { change: _vm.uploadForecast }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "primary" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.downloadTemplate.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mx-2",
                                        attrs: { dark: "", left: "" }
                                      },
                                      [_vm._v("cloud_download")]
                                    ),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("template")) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            attrs: {
                              xs4: "",
                              md2: "",
                              right: "",
                              id: "text-field"
                            }
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "append-icon": "filter_list",
                                label: _vm.$t("search"),
                                "single-line": "",
                                "hide-details": "",
                                clearable: ""
                              },
                              model: {
                                value: _vm.filter,
                                callback: function($$v) {
                                  _vm.filter = $$v
                                },
                                expression: "filter"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("v-data-table", {
              staticClass: "elevation-1",
              attrs: {
                headers: _vm.headers,
                search: _vm.filter,
                items: _vm.forecast.pkgItems || [],
                "item-key": "id"
              },
              scopedSlots: _vm._u([
                {
                  key: "headers",
                  fn: function(props) {
                    return [
                      _c(
                        "tr",
                        _vm._l(props.headers, function(header) {
                          return _c(
                            "th",
                            { key: header.text, staticClass: "text-xs-left" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(header.text) +
                                  "\n                "
                              ),
                              header.hasAction && _vm.canEdit()
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        cursor: "pointer",
                                        color: "blue"
                                      },
                                      attrs: { icon: "", small: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openBulkEditDialog(
                                            header.value
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("batch")) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  }
                },
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  disabled: _vm.isDisabledByPkg(props.item),
                                  icon: "",
                                  small: "",
                                  color: "error"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem(props.index)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("delete")])],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(_vm.getDisplayIndex(props)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "max-width": "100px" } },
                          [
                            _vm.isDisabledByPkg(props.item)
                              ? _c("v-text-field", {
                                  attrs: {
                                    disabled: true,
                                    value: "1",
                                    type: "number",
                                    dense: ""
                                  }
                                })
                              : _c("v-text-field", {
                                  attrs: {
                                    disabled: _vm.isDisabledByPkg(props.item),
                                    rules: [
                                      _vm.fieldIsRequired("quantity"),
                                      _vm.fieldIsInteger("quantity"),
                                      _vm.fieldIsNoLessThanZero("quantity")
                                    ],
                                    type: "number",
                                    dense: ""
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.handlePkgQtyChange(
                                        $event,
                                        props.item
                                      )
                                    }
                                  },
                                  model: {
                                    value: props.item.pkgQty,
                                    callback: function($$v) {
                                      _vm.$set(
                                        props.item,
                                        "pkgQty",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "props.item.pkgQty"
                                  }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "max-width": "100px" } },
                          [
                            _vm.isAddForecast && props.item.boxMark
                              ? _c("v-text-field", {
                                  attrs: {
                                    disabled: _vm.isDisabledByPkg(props.item),
                                    dense: ""
                                  },
                                  model: {
                                    value: props.item.boxMark,
                                    callback: function($$v) {
                                      _vm.$set(
                                        props.item,
                                        "boxMark",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "props.item.boxMark"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                disabled: _vm.isDisabledByPkg(props.item),
                                dense: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.handleTrackingChange(
                                    $event,
                                    props.item
                                  )
                                }
                              },
                              model: {
                                value: props.item.tracking,
                                callback: function($$v) {
                                  _vm.$set(
                                    props.item,
                                    "tracking",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "props.item.tracking"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _vm._l(props.item.upcs, function(item, i) {
                              return _c(
                                "v-layout",
                                {
                                  key: props.index + "-" + i,
                                  attrs: { row: "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          disabled: "",
                                          "hide-details": "",
                                          dense: ""
                                        },
                                        model: {
                                          value: item.upc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "upc",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "item.upc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      disabled: _vm.isDisabledByPkg(props.item),
                                      small: "",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showSelectUpcPopup(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("add sku")]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _vm._l(props.item.upcs, function(item, i) {
                              return _c(
                                "v-layout",
                                {
                                  key: props.index + "-" + i + "-name",
                                  attrs: { row: "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          disabled: _vm.isDisabledByPkg(
                                            props.item
                                          ),
                                          "hide-details": "",
                                          dense: ""
                                        },
                                        model: {
                                          value: item.productName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "productName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "item.productName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("v-layout", { attrs: { row: "", "mt-5": "" } })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _vm._l(props.item.upcs, function(item, i) {
                              return _c(
                                "v-layout",
                                {
                                  key: props.index + "-" + i + "-qty",
                                  attrs: { row: "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: [
                                            _vm.fieldIsRequired("quantity"),
                                            _vm.fieldIsInteger("quantity"),
                                            _vm.fieldIsNoLessThanZero(
                                              "quantity"
                                            )
                                          ],
                                          disabled: _vm.isDisabledByPkg(
                                            props.item
                                          ),
                                          "hide-details": "",
                                          type: "number",
                                          dense: ""
                                        },
                                        model: {
                                          value: item.forecastQty,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "forecastQty",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.forecastQty"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("v-layout", { attrs: { row: "", "mt-5": "" } })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _vm._l(props.item.upcs, function(item, i) {
                              return _c(
                                "v-layout",
                                {
                                  key: props.index + "-" + i + "-qty",
                                  staticClass: "mb-2",
                                  attrs: { row: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled: _vm.isDisabledByPkg(
                                          props.item
                                        ),
                                        icon: "",
                                        small: "",
                                        color: "error"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeUpc(props.item, i)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("v-layout", { attrs: { row: "", "mt-5": "" } })
                          ],
                          2
                        )
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _vm.isAddForecast
              ? _c(
                  "v-layout",
                  { staticClass: "mt-4", attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", md4: "" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-2",
                            attrs: { outlined: "", tile: "" }
                          },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                "Total products: " + _vm._s(_vm.totalProducts)
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", md4: "" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-2",
                            attrs: { outlined: "", tile: "" }
                          },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                "Total number of boxes: " +
                                  _vm._s(_vm.totalBoxes)
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.importErrors.length
              ? _c(
                  "v-layout",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "error-card pa-3",
                            attrs: { outlined: "" }
                          },
                          [
                            _c("div", { staticClass: "subtitle-1 mb-2" }, [
                              _vm._v(_vm._s(_vm.$t("importErrors")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              _vm._l(_vm.importErrors, function(error, index) {
                                return _c(
                                  "v-list-tile",
                                  { key: index },
                                  [
                                    _c(
                                      "v-list-tile-title",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          { staticClass: "error--text" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(_vm.$t("row")) +
                                                " " +
                                                _vm._s(error.row) +
                                                ": " +
                                                _vm._s(error.message) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "mt-3": "" } },
              [
                _c("v-textarea", {
                  staticClass: "thinBox",
                  attrs: {
                    label: _vm.$t("note"),
                    outline: "",
                    disabled: !_vm.canEdit(),
                    rows: "3",
                    counter: "200"
                  },
                  model: {
                    value: _vm.forecast.note,
                    callback: function($$v) {
                      _vm.$set(_vm.forecast, "note", $$v)
                    },
                    expression: "forecast.note"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.bulkEditDialog
              ? _c("FormSubmitPopup", {
                  attrs: {
                    title:
                      _vm.$t("batch change") +
                      " " +
                      _vm.$t(_vm.currentEditField),
                    rightMethod: _vm.applyBulkEdit,
                    small: ""
                  },
                  on: { popupClose: _vm.closeBulkEditDialog },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c("v-text-field", {
                              attrs: {
                                rules: [
                                  _vm.fieldIsRequired("quantity"),
                                  _vm.fieldIsInteger("quantity"),
                                  _vm.fieldIsNoLessThanZero("quantity")
                                ]
                              },
                              model: {
                                value: _vm.bulkEditValue,
                                callback: function($$v) {
                                  _vm.bulkEditValue = _vm._n($$v)
                                },
                                expression: "bulkEditValue"
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1026015087
                  ),
                  model: {
                    value: _vm.bulkEditDialog,
                    callback: function($$v) {
                      _vm.bulkEditDialog = $$v
                    },
                    expression: "bulkEditDialog"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelectUpcPopup
              ? _c("FormSubmitPopup", {
                  attrs: {
                    title: _vm.$t("selectProduct"),
                    rightMethod: _vm.applyPackage,
                    rightButtonDisabled: !_vm.selectedUPC.length,
                    hasAlert: "",
                    rightButtonLoading: _vm.isLoading,
                    medium: ""
                  },
                  on: {
                    popupClose: function() {
                      _vm.isSelectUpcPopup = false
                      _vm.reset()
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "v-layout",
                              { attrs: { "text-right": "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "append-icon": "filter_list",
                                    label: _vm.$t("search"),
                                    "single-line": "",
                                    "hide-details": "",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.search,
                                    callback: function($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-data-table", {
                              staticClass: "elevation-1",
                              attrs: {
                                headers: _vm.upcHeaders,
                                items: _vm.productsWithDimensions,
                                "items-per-page": 25,
                                search: _vm.search,
                                "item-key": "upc",
                                "select-all": "blue"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "checkbox-align-center",
                                            on: {
                                              click: function($event) {
                                                props.selected = !props.selected
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-layout",
                                              [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: props.selected,
                                                    primary: "",
                                                    "hide-details": ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return function() {
                                                        props.selected = !props.selected
                                                      }.apply(null, arguments)
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.upc))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.name))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (props.item.length || 0) +
                                                  "/" +
                                                  (props.item.width || 0) +
                                                  "/" +
                                                  (props.item.height || 0) +
                                                  "\n              " +
                                                  _vm.getUnit(props.item.unit)
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2396021890
                              ),
                              model: {
                                value: _vm.selectedUPC,
                                callback: function($$v) {
                                  _vm.selectedUPC = $$v
                                },
                                expression: "selectedUPC"
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    51870420
                  ),
                  model: {
                    value: _vm.isSelectUpcPopup,
                    callback: function($$v) {
                      _vm.isSelectUpcPopup = $$v
                    },
                    expression: "isSelectUpcPopup"
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6399a2d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6399a2d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropshippingForecastPopup.vue
// module id = null
// module chunks = 